<section class="w-[90vw] max-w-[calc(100vw-2rem)] rounded-[1.5rem] border border-lGray700 bg-lGray900 p-6 shadow-soft-black md:w-[31rem]">
  <h2 class="text-center text-base font-medium text-lGray300">{{ title }}</h2>

  @if (showDivider) {
    <div class="my-4 h-px w-full bg-lGray700"></div>
  }

  @if (description) {
    <p class="text-center text-base text-lWhite">{{ description }}</p>
  }

  <div class="mt-6 flex flex-col gap-3 sm:flex-row">
    @for (button of buttons; track button.id) {
      <button
        lButton
        [bType]="button.type ?? buttonTypeEnum.PRIMARY"
        [bSize]="button.size ?? buttonSizeEnum.MEDIUM"
        [bRadius]="button.radius ?? buttonRadiusEnum.CIRCLE"
        [outline]="button.outline || false"
        [disabled]="button.disabled"
        class="!h-11 !min-w-0 !w-full"
        (click)="handleButtonClick(button)"
      >
        {{ button.label }}
      </button>
    }
  </div>
</section>